import { useFormik } from "formik";
import React, { useState } from "react";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import DataTable from "react-data-table-component";
import CustomModal from "../../../../components/common/Modal";
import { useToggleState } from "../../../../Hooks/useToggleState";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import {
   addSingleCustomerChildAsync,
   fetchSingleCustomerMasterAsync,
   updateSingleCustomerChildAsync,
   removeContactAsync,
} from "../../../../redux/features/customerMaster";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import validation from "../../../../helpers/validation";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";

const ContactPerson = ({ contactPersonList }) => {
   const params = useParams();
   const dispatch = useDispatch();

   const [action, setAction] = useState("");
   const [initialState, setInitialState] = useState({
      id: "",
      name: "",
      mobile: "",
      email: "",
   });
   const [isChecked, setIsChecked] = useState({}); // State to manage toggle

   const [isModalVisible, handleShowModal, handleCloseModal] = useToggleState();

   const formik = useFormik({
      initialValues: initialState,
      enableReinitialize: true,
      validationSchema: yup.object().shape({
         name: validation.name(),
         mobile: validation.mobile,
         email: validation.email,
      }),
      onSubmit: action === "add" ? handleContactPersonAdd : handleContactPersonUpdate,
   });

   const {
      touched,
      errors,
      values,
      getFieldProps,
      handleSubmit,
      resetForm,
      setFieldValue,
      setValues,
   } = formik;

   const toggleSwitch = () => {
      setIsChecked(isChecked ? (isChecked = true) : (isChecked = false)); // Toggle the state
   };

   const columns = [
      {
         name: "Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Email",
         selector: (row) => row.email,
      },
      {
         name: "Mobile Number",
         selector: (row) => row.mobile,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => row.action,
      },
   ];

   const handleDelete = (id) => {
      const confirmDelete = window.confirm(
         "Are you sure you want to delete this Kiloleter?",
      );

      if (!confirmDelete) return;

      dispatch(backdropLoadingAction(true));

      dispatch(
         removeContactAsync({
            id,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Location deleted successfully");

               // Refresh list after delete
               dispatch(
                  fetchSingleCustomerMasterAsync({
                     id: params?.id,
                     err: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                     done: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                  }),
               );
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const data = contactPersonList?.map?.((item) => ({
      ...item,
      action: (
         <div className="d-flex align-items-center">
            <button
               className="btn"
               onClick={() => {
                  setAction("edit");
                  setValues({
                     id: item?.id,
                     name: item?.name,
                     mobile: item?.mobile,
                     email: item?.email,
                  });
                  handleShowModal();
               }}
            >
               <BsPencilSquare
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>

            <button className="btn">
               <BsTrashFill
                  onClick={() => handleDelete(item?.id)}
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>

            {/* <CustomToggleSwitch
               checked={isChecked}
               onChange={toggleSwitch}
               id="csutomer6"
            /> */}
         </div>
      ),
   }));

   function handleContactPersonUpdate(data) {
      const newData = new FormData();

      newData.append("customer_master_id", params?.id);
      newData.append("contact_person_detail_id", data?.id);
      newData.append("contact_person_name[]", data?.name);
      newData.append("mobile[]", data?.mobile);
      newData.append("email[]", data?.email);

      newData.append("_method", "PATCH");
      newData.append("model_id", 6);
      newData.append("action_id", 2);

      dispatch(backdropLoadingAction(true));

      dispatch(
         updateSingleCustomerChildAsync({
            data: newData,
            err: () => {
               //toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record updated successfully !");
               handleCloseModal();
               dispatch(
                  fetchSingleCustomerMasterAsync({
                     id: params?.id,
                     err: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                     done: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                  }),
               );
            },
         }),
      );
   }

   function handleContactPersonAdd(data) {
      const newData = new FormData();

      newData.append("customer_master_id", params?.id);
      newData.append("contact_person_name[]", data?.name);
      newData.append("mobile[]", data?.mobile);
      newData.append("email[]", data?.email);
      newData.append("model_id", 6);
      newData.append("action_id", 1);

      dispatch(backdropLoadingAction(true));

      dispatch(
         addSingleCustomerChildAsync({
            data: newData,
            err: () => {
               //toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record added successfully !");
               handleCloseModal();
               dispatch(
                  fetchSingleCustomerMasterAsync({
                     id: params?.id,
                     err: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                     done: () => {
                        dispatch(backdropLoadingAction(false));
                     },
                  }),
               );
            },
         }),
      );
   }

   return (
      <>
         <CustomModal
            showModal={isModalVisible}
            handleCloseModal={() => {
               resetForm();
               handleCloseModal();
            }}
            modalSize="modal-md"
            title="Contact Person"
            onSubmit={handleSubmit}
            child={
               <>
                  <div>
                     <CustomInput
                        require
                        label="Contact Person Name"
                        id="contactPersonName"
                        placeholder="Enter Contact Person Name"
                        {...getFieldProps(`name`)}
                        errors={touched?.name && errors?.name}
                        message={errors?.name}
                     />
                  </div>
                  <div>
                     <CustomInput
                        require
                        label="Customer Mobile No"
                        id="customerMobileNo"
                        maxLength={10}
                        placeholder="Enter Customer Mobile No"
                        {...getFieldProps(`mobile`)}
                        errors={touched?.mobile && errors?.mobile}
                        message={errors?.mobile}
                     />
                  </div>
                  <div>
                     <CustomInput
                        require
                        label="Customer Email Id"
                        id="customerEmailId"
                        placeholder="Enter Customer Email Id"
                        {...getFieldProps(`email`)}
                        errors={touched?.email && errors?.email}
                        message={errors?.email}
                     />
                  </div>
               </>
            }
         />
         <div className="d-flex w-100 mb-2 justify-content-between align-items-end">
            <label className="text-bold">Contact person details</label>
            <button
               type="button"
               className="btn btn-primary"
               onClick={() => {
                  setAction("add");
                  setValues({
                     id: "",
                     name: "",
                     mobile: "",
                     email: "",
                  });
                  handleShowModal();
               }}
            >
               <i className="fas fa-plus"></i> Add More
            </button>
         </div>

         <CustomTable columns={columns} data={data} />
      </>
   );
};

export default ContactPerson;
